import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { CategoryGroupBy, typeToDisplay } from './GroupByHelper'

export const ViewChart: React.FunctionComponent = (props) => {

    const [type, setType] = React.useState<string>()
    const toolbarItems = CategoryGroupBy({ onTypeChange: setType, preventSubGenre: true })
    if (!type) {
        return null
    }

    return (
        <BPMChart {...props} title='Number of Views' subTitle={'By ' + typeToDisplay(type)} type='tree'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>('categories/views', options, signal)
            }} additionalParams={{ type: type }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: 'Number of Views',
                valueField: 'count',
                argumentField: 'name',
                smallValuesGrouping: { topCount: 20, mode: 'topN' }
            }} doesNotSupportQuery>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Category/charts/ViewChart.tsx